import React from "react";

import styles from "./style.module.css";

export default class ButtonGroup extends React.PureComponent {
  render() {
    const { className, ...retProps } = this.props;

    return (
      <div {...retProps} className={styles.buttonGroup + (className ? " " + className : "")}>
        {this.props.children}
      </div>
    );
  }
}
